// extracted by mini-css-extract-plugin
export default {"promoCodeInput":"PromoCode_promoCodeInput--zZ0","promocodeWrapper":"PromoCode_promocodeWrapper--uYm"};